import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto w-full py-10 px-4">
      <header className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-900">利用規約</h1>
      </header>

      <section className="bg-white rounded-lg border border-gray-200 p-8 prose prose-sm max-w-none">
        <p className="text-sm text-gray-600 mb-6">
          本利用規約(以下「本規約」といいます。)は、東京商工会議所(以下「運営者」といいます。)が提供する「BCP作成AIサービス(SONAE-AI)」(以下「本サービス」といいます。)の利用条件を定めるものです。利用者の皆さま(以下「利用者」といいます。)には、本規約に同意の上、本サービスをご利用いただきます。
        </p>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第1条(目的)</h2>
        <p className="text-sm text-gray-700 mb-6">
          本規約は、本サービスの提供条件及び利用に関する運営者と利用者との間の権利義務関係を定めることを目的とします。
        </p>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第2条(定義)</h2>
        <p className="text-sm text-gray-700 mb-2">本規約における用語の定義は、以下のとおりとします。</p>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>「本サービス」とは、運営者が提供する、生成AI技術を用いてBCP(事業継続計画)の作成を支援するオンラインサービスをいいます。</li>
          <li>「利用者」とは、本サービスを利用する法人または個人(ただし、事業のために本サービスを利用する者に限る。)をいいます。</li>
          <li>「生成コンテンツ」とは、本サービスを通じてAIが出力する文書その他の情報をいいます。</li>
          <li>「利用者データ」とは、利用者が本サービスに入力する企業情報、財務情報、事業計画、その他の営業秘密を含む一切のデータをいいます。</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第3条(適用範囲)</h2>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>本規約は、利用者と運営者との間の本サービスの利用に関わる一切の関係に適用されるものとします。</li>
          <li>運営者は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め(以下「個別規程」といいます。)をすることがあります。これら個別規程はその名称のいかんに関わらず、本規約の一部を構成するものとします。</li>
          <li>本規約の規程が前項の個別規程の規程と矛盾する場合には、個別規程において特段の定めなき限り、個別規程の規程が優先されるものとします。</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第4条(利用資格)</h2>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>本サービスは、原則として、運営者の会員企業かつ、東商マイページの登録者を対象とします。</li>
          <li>非会員は、運営者が承認した場合に限り本サービスを利用できます。</li>
          <li>利用者は、自己の業務遂行の範囲内でのみ本サービスを利用するものとし、利用に必要な情報を第三者に譲渡・転貸してはなりません。</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第5条(利用料金)</h2>
        <p className="text-sm text-gray-700 mb-6">
          本サービスは、原則として無料で提供します。ただし、将来的に一部機能について有料とする場合があります。その場合は、運営者が別途定める方法により告知します。
        </p>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第6条(利用者の義務)</h2>
        <p className="text-sm text-gray-700 mb-2">利用者は、本サービスを利用するにあたり、以下を遵守するものとします。</p>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>正確かつ最新の情報を入力すること</li>
          <li>入力する情報(利用者の機密情報や個人情報を含むが、これに限られない。)は、その管理について運営者が一切の責任を負わないことその他本規約の定める条件のもとで、利用者自身の責任において判断すること</li>
          <li>自己の責任において生成コンテンツを確認・修正のうえ活用すること</li>
          <li>法令・規則・公序良俗に反しないこと</li>
          <li>第三者の権利を侵害しないこと</li>
          <li>本サービスを不正または不適切に利用しないこと</li>
          <li>本サービスを通じて得た情報を不正に利用しないこと</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第7条(禁止事項)</h2>
        <p className="text-sm text-gray-700 mb-2">利用者は、本サービスの利用に際し、以下の行為を行ってはなりません。</p>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>個人である利用者が事業とは無関係に本サービスを利用する行為</li>
          <li>虚偽または誤解を招く情報の入力</li>
          <li>第三者の知的財産権・肖像権・プライバシー権を侵害する内容の入力または利用</li>
          <li>利用者データの管理について運営者が一切の責任を負わないことその他本規約の定める条件のもとでは入力に適さない情報を入力する行為、または第三者の個人情報を無断で入力する行為</li>
          <li>生成コンテンツを修正・検証することなく、公式文書・契約書・対外的な資料等にそのまま利用または公開する行為</li>
          <li>出力結果を違法・有害な目的で利用する行為</li>
          <li>本サービスまたは生成コンテンツを利用して、無償・有償問わず、第三者に対してコンサルティング、助言、レポート提供、その他これらに類する役務を提供する行為</li>
          <li>本サービスのリバースエンジニアリング、解析、改変する行為</li>
          <li>本サービスの運営を妨害する行為</li>
          <li>法令または公序良俗に違反する行為</li>
          <li>犯罪行為に関連する行為</li>
          <li>不正アクセスをし、またはこれを試みる行為</li>
          <li>他の利用者に関する個人情報等を収集または蓄積する行為</li>
          <li>不正な目的を持って本サービスを利用する行為</li>
          <li>本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為</li>
          <li>他の利用者に成りすます行為</li>
          <li>運営者のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
          <li>その他、運営者が不適切と判断する行為</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第8条(サービスの変更・中断・停止)</h2>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>運営者は、システム保守、障害対応、天災地変、通信障害その他やむを得ない事由により、本サービスの内容変更、中断、停止、または終了を行うことがあります。</li>
          <li>前項の措置は、利用者への事前通知なしに行われる場合があります。</li>
          <li>運営者は、前項に基づくサービスの内容変更、中断、停止または終了によって利用者または第三者に生じた損害について、一切の責任を負いません。</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第9条(知的財産権)</h2>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>本サービスに関するプログラム、システム、ノウハウ等の知的財産権は、運営者または正当な権利者に帰属します。</li>
          <li>生成コンテンツについては、利用者は業務上利用する権利を有しますが、第三者の権利侵害をしない範囲に限られます。</li>
          <li>運営者は、生成コンテンツが第三者の権利を侵害しないことを保証しません。</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第10条(データ取扱い・秘密保持)</h2>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>利用者データの所有権および管理責任は利用者に帰属します。</li>
          <li>運営者は、利用者データを本サービス提供の目的の範囲内でのみ利用し、利用者の事前承諾なくAIモデルの追加学習、第三者への提供、その他の二次利用に用いません。</li>
          <li>運営者は、技術的・組織的安全管理措置を講じ利用者データの漏洩の防止に努めますが、運営者の故意による場合を除き、利用者データの管理について一切の責任を負いません。</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第11条(利用停止)</h2>
        <p className="text-sm text-gray-700 mb-6">
          運営者は、利用者が本規約に違反した場合、事前通知なく本サービスの利用を停止することができます。
        </p>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第12条(サービス内容及び免責)</h2>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>本サービスは、生成AIにより参考情報を提示するものであり、生成コンテンツの正確性、完全性、適合性、有用性を保証するものではありません。</li>
          <li>利用者は、生成コンテンツを自己の責任で検証・修正しなければならず、運営者はその結果について責任を負いません。</li>
          <li>本サービスはBCP策定を支援するものであり、本サービスの利用によって事業継続が保証されるものではありません。利用者は、実際の事業継続に必要な対応については、必要に応じて専門家の助言を得た上で、利用者の責任において判断・実施するものとします。</li>
          <li>運営者は、以下に起因して生じた損害について責任を負いません。<br />
            (1) 通信環境の障害、不正アクセス等による損害<br />
            (2) 生成コンテンツの誤用・誤解に基づく損害<br />
            (3) 予期しない不正アクセス等の行為により利用者に生じた損害
          </li>
          <li>利用に関連して生じた損害について、運営者は、運営者の故意による場合を除き、一切責任を負いません。</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第13条(損害賠償責任の限定)</h2>
        <ol className="list-decimal pl-6 text-sm text-gray-700 mb-6 space-y-2">
          <li>運営者は、本サービスの提供に関し、運営者の故意による場合を除き、利用者に対して一切の損害賠償責任を負いません。</li>
          <li>運営者が責任を負う場合であっても、その範囲は直接かつ通常の損害に限られ、特別損害、間接損害、逸失利益及び弁護士費用については責任を負いません。</li>
          <li>利用者が故意または過失により本規約に違反し、運営者に対し損害を与えた場合、利用者は運営者に対し、その損害を賠償する義務を負担するものとします。</li>
        </ol>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第14条(本規約の変更)</h2>
        <p className="text-sm text-gray-700 mb-6">
          運営者は、適宜の方法により告知することにより本規約を変更することができるものとします。
        </p>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第15条(反社会的勢力の排除)</h2>
        <div className="text-sm text-gray-700 mb-4">
          <p className="mb-2">
            <span className="font-medium">1.</span> 利用者は、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等、その他これらに準ずる者(以下総称して「反社会的勢力」といいます。)に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約します。
          </p>
          <div className="pl-6 mb-4 space-y-2">
            <p>(1)反社会的勢力が経営を支配していると認められる関係を有すること</p>
            <p>(2)反社会的勢力が経営に実質的に関与していると認められる関係を有すること</p>
            <p>(3)自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってする等、不当に反社会的勢力を利用していると認められる関係を有すること</p>
            <p>(4)反社会的勢力に対して資金等を提供し、又は便宜を供与する等の関与をしていると認められる関係を有すること</p>
            <p>(5)役員又は経営に実質的に関与している者が反社会的勢力と社会的に非難されるべき関係を有すること</p>
          </div>

          <p className="mb-2">
            <span className="font-medium">2.</span> 利用者は、自ら又は第三者を利用して次の各号のいずれにも該当する行為を行わないことを確約します。
          </p>
          <div className="pl-6 mb-4 space-y-2">
            <p>(1)暴力的な要求行為</p>
            <p>(2)法的な責任を超えた不当な要求行為</p>
            <p>(3)取引に関して、脅迫的な言動をし、又は暴力を用いる行為</p>
            <p>(4)風説を流布し、偽計を用い又は威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為</p>
            <p>(5)その他前各号に準ずる行為</p>
          </div>

          <p className="mb-4">
            <span className="font-medium">3.</span> 運営者は、利用者が反社会的勢力若しくは第1項各号のいずれかに該当し、若しくは前項各号のいずれかに該当する行為をし、又は第1項の規程にもとづく表明・確約に関して虚偽の申告をしたことが判明した場合には、自己の責に帰すべき事由の有無を問わず、利用者に対して何らの催告をすることなく本サービスの利用を禁止することができます。
          </p>

          <p className="mb-6">
            <span className="font-medium">4.</span> 利用者は、前項により運営者が本サービスの利用を禁止した場合、利用者に損害が生じたとしてもこれを一切賠償する責任はないことを確認し、これを了承します。
          </p>
        </div>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第16条(準拠法・管轄)</h2>
        <p className="text-sm text-gray-700 mb-6">
          本規約は、日本法を準拠法とし、本サービスの利用者と、運営者の間で生じた紛争については、東京地方裁判所を第一審の専属合意管轄裁判所とします。
        </p>

        <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-4">第17条(規約の承諾)</h2>
        <p className="text-sm text-gray-700 mb-6">
          本サービスの利用者は、本サービスを利用することによって、本規約の内容に同意したものとみなします。
        </p>
      </section>
    </div>
  );
};

export default TermsPage;
